'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _faAngleLeft = require('@fortawesome/fontawesome-pro-solid/faAngleLeft');

var _faAngleLeft2 = _interopRequireDefault(_faAngleLeft);

var _faCalendarAlt = require('@fortawesome/fontawesome-pro-regular/faCalendarAlt');

var _faCalendarAlt2 = _interopRequireDefault(_faCalendarAlt);

var _faCameraAlt = require('@fortawesome/fontawesome-pro-solid/faCameraAlt');

var _faCameraAlt2 = _interopRequireDefault(_faCameraAlt);

var _faCaretDown = require('@fortawesome/fontawesome-pro-solid/faCaretDown');

var _faCaretDown2 = _interopRequireDefault(_faCaretDown);

var _faCaretLeft = require('@fortawesome/fontawesome-pro-solid/faCaretLeft');

var _faCaretLeft2 = _interopRequireDefault(_faCaretLeft);

var _faCaretRight = require('@fortawesome/fontawesome-pro-solid/faCaretRight');

var _faCaretRight2 = _interopRequireDefault(_faCaretRight);

var _faCaretUp = require('@fortawesome/fontawesome-pro-solid/faCaretUp');

var _faCaretUp2 = _interopRequireDefault(_faCaretUp);

var _faCheckCircle = require('@fortawesome/fontawesome-pro-solid/faCheckCircle');

var _faCheckCircle2 = _interopRequireDefault(_faCheckCircle);

var _faChevronLeft = require('@fortawesome/fontawesome-pro-solid/faChevronLeft');

var _faChevronLeft2 = _interopRequireDefault(_faChevronLeft);

var _faChevronRight = require('@fortawesome/fontawesome-pro-solid/faChevronRight');

var _faChevronRight2 = _interopRequireDefault(_faChevronRight);

var _faClock = require('@fortawesome/fontawesome-pro-regular/faClock');

var _faClock2 = _interopRequireDefault(_faClock);

var _faEnvelope = require('@fortawesome/fontawesome-pro-solid/faEnvelope');

var _faEnvelope2 = _interopRequireDefault(_faEnvelope);

var _faExclamationCircle = require('@fortawesome/fontawesome-pro-solid/faExclamationCircle');

var _faExclamationCircle2 = _interopRequireDefault(_faExclamationCircle);

var _faExclamationTriangle = require('@fortawesome/fontawesome-pro-solid/faExclamationTriangle');

var _faExclamationTriangle2 = _interopRequireDefault(_faExclamationTriangle);

var _faEye = require('@fortawesome/fontawesome-pro-regular/faEye');

var _faEye2 = _interopRequireDefault(_faEye);

var _faEyeSlash = require('@fortawesome/fontawesome-pro-regular/faEyeSlash');

var _faEyeSlash2 = _interopRequireDefault(_faEyeSlash);

var _faHeart = require('@fortawesome/fontawesome-pro-regular/faHeart');

var _faHeart2 = _interopRequireDefault(_faHeart);

var _faHeart3 = require('@fortawesome/fontawesome-pro-solid/faHeart');

var _faHeart4 = _interopRequireDefault(_faHeart3);

var _faHourglassStart = require('@fortawesome/fontawesome-pro-regular/faHourglassStart');

var _faHourglassStart2 = _interopRequireDefault(_faHourglassStart);

var _faLightbulb = require('@fortawesome/fontawesome-pro-light/faLightbulb');

var _faLightbulb2 = _interopRequireDefault(_faLightbulb);

var _faLock = require('@fortawesome/fontawesome-pro-solid/faLock');

var _faLock2 = _interopRequireDefault(_faLock);

var _faMobileAlt = require('@fortawesome/fontawesome-pro-solid/faMobileAlt');

var _faMobileAlt2 = _interopRequireDefault(_faMobileAlt);

var _faPlay = require('@fortawesome/fontawesome-pro-solid/faPlay');

var _faPlay2 = _interopRequireDefault(_faPlay);

var _faQuestionCircle = require('@fortawesome/fontawesome-pro-solid/faQuestionCircle');

var _faQuestionCircle2 = _interopRequireDefault(_faQuestionCircle);

var _faSearch = require('@fortawesome/fontawesome-pro-solid/faSearch');

var _faSearch2 = _interopRequireDefault(_faSearch);

var _faSpinner = require('@fortawesome/fontawesome-pro-solid/faSpinner');

var _faSpinner2 = _interopRequireDefault(_faSpinner);

var _faUsdCircle = require('@fortawesome/fontawesome-pro-solid/faUsdCircle');

var _faUsdCircle2 = _interopRequireDefault(_faUsdCircle);

var _faTachometerAlt = require('@fortawesome/fontawesome-pro-solid/faTachometerAlt');

var _faTachometerAlt2 = _interopRequireDefault(_faTachometerAlt);

var _faTimes = require('@fortawesome/fontawesome-pro-solid/faTimes');

var _faTimes2 = _interopRequireDefault(_faTimes);

var _faUsdCircle3 = require('@fortawesome/fontawesome-pro-regular/faUsdCircle');

var _faUsdCircle4 = _interopRequireDefault(_faUsdCircle3);

var _fontawesome = require('@fortawesome/fontawesome');

var _fontawesome2 = _interopRequireDefault(_fontawesome);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesome2.default.library.add(_faAngleLeft2.default, _faCalendarAlt2.default, _faCameraAlt2.default, _faCaretDown2.default, _faCaretLeft2.default, _faCaretRight2.default, _faCaretUp2.default, _faCheckCircle2.default, _faChevronLeft2.default, _faChevronRight2.default, _faClock2.default, _faEnvelope2.default, _faExclamationCircle2.default, _faExclamationTriangle2.default, _faEye2.default, _faEyeSlash2.default, _faHeart2.default, _faHeart4.default, _faHourglassStart2.default, _faLightbulb2.default, _faLock2.default, _faMobileAlt2.default, _faPlay2.default, _faQuestionCircle2.default, _faSearch2.default, _faSpinner2.default, _faUsdCircle2.default, _faTachometerAlt2.default, _faTimes2.default, _faUsdCircle4.default);

var FontAwesome = function (_PureComponent) {
    (0, _inherits3.default)(FontAwesome, _PureComponent);

    function FontAwesome() {
        (0, _classCallCheck3.default)(this, FontAwesome);
        return (0, _possibleConstructorReturn3.default)(this, (FontAwesome.__proto__ || (0, _getPrototypeOf2.default)(FontAwesome)).apply(this, arguments));
    }

    (0, _createClass3.default)(FontAwesome, [{
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return FontAwesome;
}(_react.PureComponent);

exports.default = FontAwesome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/FontAwesome.js
// module id = 5tCn
// module chunks = 57